import { useAtomValue } from 'jotai';
import { createPortal } from 'react-dom';

import { bottomStickyPortalAtom } from '../app-layout.state';

interface BottomStickyPortalProps {
  children: React.ReactNode;
}

export const BottomStickyPortal = ({ children }: BottomStickyPortalProps) => {
  const bottomStickyPortal = useAtomValue(bottomStickyPortalAtom);

  return bottomStickyPortal && createPortal(children, bottomStickyPortal as HTMLElement);
};
